import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { Reveal } from '../Reveal';
import { pains } from '../../data/content';
export function PainsSection() {
  return <section className="bg-cream py-16 md:py-[84px]" data-id="element-177" data-mp="31tkddaou86ml">
      <div className="mx-auto max-w-[1120px] px-5" data-id="element-178" data-mp="35tukiqod9331">
        <SectionHeading kicker="¿Te suena?" icon={AlertTriangle} title={<>
              Amas a los perros…
              <br data-id="element-180" data-mp="2e2eusnrij08l" />
              pero el negocio te está <em data-id="element-181" data-mp="2e36g95rebhl5">costando caro</em>
            </>} lead="Si trabajas paseando o cuidando mascotas, seguro viviste alguna de estas situaciones:" data-id="element-179" data-mp="35taz2zzibwk9" />
        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-182" data-mp="2mv8dkv664hr7">
          {pains.map((pain, i) => <li key={pain} data-id="element-183" data-mp="1qdvnobk78ti3" data-mpi={i}>
              <Reveal delay={i * 0.04} className="flex h-full items-start gap-4 rounded-[18px] border border-line bg-white px-[22px] py-5 text-[16.5px]" data-id="element-184" data-mp="1qckkacuo1nri">
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-danger-soft" data-id="element-185" data-mp="1pcx0quv1zpbu">
                  <X className="h-[18px] w-[18px] text-danger" strokeWidth={2.6} aria-hidden="true" data-id="element-186" data-mp="1kgganv4an0w4" />
                </span>
                <span className="pt-1.5 leading-snug" data-id="element-187" data-mp="1aojzpjh3zgah">{pain}</span>
              </Reveal>
            </li>)}
        </ul>
        <Reveal className="mx-auto mt-10 max-w-[720px] rounded-[22px] bg-forest px-[30px] py-7 text-center font-display text-[19px] font-semibold leading-snug text-cream md:text-2xl" data-id="element-188" data-mp="15pphojqytvrf">
          No es falta de amor por los perros.{' '}
          <em className="not-italic text-tangerine-light" data-id="element-189" data-mp="wp139nxntte0">Es falta de sistema.</em>
          <br data-id="element-190" data-mp="rqzjf0setq1h" />Y el sistema ya está hecho.
        </Reveal>
      </div>
    </section>;
}